var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundSpot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 515.48 360.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f8f8ff",
    d: "M884,552c-7.73-51.51-25-56-38.28-82-12.09-23.65-21.84-62.34,12.28-90,53-43,118,1,118,1s103,59,121,62,62,33,117-3,102-33,117-6-19,105-27,121,4,66,17,86,54,82-34,80-352,1-352,1-94.77-1.77-78-94C871,551,887,572,884,552Z",
    transform: "translate(-834.52 -361.14)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.48,
    cy: 163.86,
    r: 20,
    fill: "#bac5f4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.98,
    cy: 188.36,
    r: 13.5,
    fill: "#bac5f4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.98,
    cy: 157.36,
    r: 7.5,
    fill: "#bac5f4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 495.48,
    cy: 298.86,
    r: 20,
    fill: "#bac5f4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.98,
    cy: 62.36,
    r: 7.5,
    fill: "#bac5f4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139.98,
    cy: 297.36,
    r: 35.5,
    fill: "#e1e6fb"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.48,
    cy: 325.86,
    r: 24,
    fill: "#e1e6fb"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466.48,
    cy: 201.86,
    r: 13,
    fill: "#e1e6fb"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.48,
    cy: 84.86,
    r: 26,
    fill: "#e1e6fb"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.98,
    cy: 15.36,
    r: 12.5,
    fill: "#e1e6fb"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.98,
    cy: 264.36,
    r: 12.5,
    fill: "#e1e6fb"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 493.98,
    cy: 119.36,
    r: 12.5,
    fill: "#bac5f4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 473.98,
    cy: 331.36,
    r: 13.5,
    fill: "#bac5f4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 503.98,
    cy: 338.36,
    r: 7.5,
    fill: "#bac5f4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundSpot);
export default __webpack_public_path__ + "static/media/background-spot.a57159a246fe92e7ea78e89e166829b5.svg";
export { ForwardRef as ReactComponent };